import React from "react";
import "./Banner.css";
import { Link , useNavigate } from "react-router-dom";
import LeftIcon from "../../../Assets/Icons/LeftIcon";

const Banner= () => {
  const navigate = useNavigate();
  return (
    <div className="sp-banner sct-banner ">
      <div className="sp-banner-content sc-banner-content ">
        <div className='maxWidth-content'>
        <Link onClick={()=>navigate(-1)}>
          <LeftIcon />
        </Link>
        <h1>Summer Camp</h1>
        </div>
      </div>
    </div>
  );
};

export default Banner;
